const actions = {
  setFilter({ commit, dispatch }, payload) {
    commit("setFilter", payload);
  }
};

export default actions;
